import { combineReducers } from 'redux'

import invoices from './invoices'
import inventories from './inventory'
import clients from './clients'
import vendors from './vendors'
import metals from './metals'
import shipping from './shipping'
import auth from './auth'
import profiles from './profiles'

export default combineReducers({ invoices, inventories, clients,vendors, metals, shipping, auth, profiles })